import React from 'react'
import { Button } from 'reactstrap'
import EditIcon from '@mui/icons-material/Edit'
import { CircularProgress } from '@mui/material'

function EditButton(props) {
  const { onClick, loading, disablediv } = props
  if (disablediv) {
    return (
      <Button color='success' size='sm' disabled={loading} onClick={onClick}>
        {loading ?
          <CircularProgress size={10} color={'inherit'} /> :
          <EditIcon fontSize={'inherit'} />
        }
    {' Muokkaa'}</Button>
    )
  }
  return (
    <div className='actions-right'>
      <Button color='success' size='sm' disabled={loading} onClick={onClick}>
        {loading ?
          <CircularProgress size={10} color={'inherit'} /> :
        <EditIcon fontSize={'inherit'} />
        }
    {' Muokkaa'}</Button></div>
  )
}

export default EditButton